import React from 'react';
import './Kontak.css';


class Kontak extends React.Component {
   
    render () {
      return (
        <div className=" kontak jumbotron jumbotron-fluid">
            <div className="container">
                <h1>Kontak</h1>
                <div className="row">
                      <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="content">
                            <i className="fa fa-mobile"></i>
                            <p>
                                Phone : +62 877-8648-1960  <br/>
                                <span>Phone : +62 822-4615-1660 </span>
                            </p>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="content">
                            <i className="fa fa-map-marker"></i>
                            <p>
                            Cluster Chalcedony Blok G27 No.7<br/>
                                <span>Citra Raya Cikupa Tangerang</span>
                            </p>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="content">
                            <i className="fa fa-envelope-o"></i>
                            <p>
                                Email 1: admin@ladangshop.com<br/>
                                <span>Email 2: support@ladangshop.com</span>
                            </p>
                        </div>
                      </div>
                    </div>
            </div>
        </div>
      );
    }
  }


export default Kontak;
